export default __webpack_public_path__ + "static/media/emotional-reunion.fecbca68.gif";